
import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'

class ReportContractor extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  render(){
    return (
      <div>
        <Box>
          <Box.Title>
            ''
          </Box.Title>
        </Box>
      </div>
    )
  }
}


export default ReportContractor;





// WEBPACK FOOTER //
// ./src/view/report/ReportContractor.js